export class BestandsbuchArtikelAnwendung {
    baa_id: number;
    datum: Date;
    angewendet: number;
    anzahl_tiere: number;
}
